import { Shield, Lock, KeyRound, EyeOff, Globe, Facebook, Instagram, Mail } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import Emblem from "./Emblem";

const SOCIALS = [
  { icon: Globe, label: "www.javieralagrande.com", href: "https://www.javieralagrande.com", testId: "footer-link-web" },
  { icon: Facebook, label: "Javier Alagrande", href: "https://www.facebook.com/javieralagrande", testId: "footer-link-facebook" },
  { icon: Instagram, label: "@alagrandejavier", href: "https://www.instagram.com/alagrandejavier", testId: "footer-link-instagram" },
  { icon: Mail, label: "javier.alagrande@proton.me", href: "mailto:javier.alagrande@proton.me", testId: "footer-link-email" },
];

const Footer = () => {
  const { t } = useLang();
  return (
  <footer data-testid="footer-section" className="relative border-t border-[#F4F1EA]/10 bg-[#0B0B0C]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="flex flex-col items-center text-center gap-8">
        <Emblem className="w-24 h-auto opacity-90" animate={false} />

        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-testid="footer-socials">
          {SOCIALS.map(({ icon: Icon, label, href, testId }) => (
            <a
              key={testId}
              data-testid={testId}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-xs text-[#A0A0A5] hover:text-[#D4AF37] transition-colors duration-300"
            >
              <Icon className="w-4 h-4 text-[#C5A059]" />
              {label}
            </a>
          ))}
        </div>

        <p
          data-testid="footer-security-notice"
          className="max-w-xl text-xs leading-relaxed text-[#8E8E93]"
        >
          <span className="font-code tracking-[0.25em] uppercase text-[#C5A059] block mb-2">
            {t("footer.noticeTitle")}
          </span>
          {t("footer.notice")}
        </p>

        <div className="flex items-center gap-6" data-testid="footer-encrypted-icons">
          {[Shield, Lock, KeyRound, EyeOff].map((Icon, i) => (
            <span
              key={i}
              className="w-10 h-10 flex items-center justify-center border border-[#F4F1EA]/10 text-[#C5A059] hover:border-[#D4AF37]/50 hover:text-[#D4AF37] transition-colors duration-300"
            >
              <Icon className="w-4 h-4" />
            </span>
          ))}
        </div>

        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />

        <p data-testid="footer-copyright" className="font-code text-[11px] tracking-[0.25em] uppercase text-[#8E8E93]">
          © 2026 <span className="text-[#D4AF37]">Javier Alagrande</span> {t("footer.rights")}
        </p>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
